/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorNewScorecardAttributeNewValueRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.new-scorecard.attribute-new.value',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorNewScorecardAttributeNewValueRoute);
